import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { WiresSuccessPage } from '@egw/features-transfer'

export const SuccessWirePage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.transfer.title')} />
      <WiresSuccessPage />
    </Layout>
  )
}
